import { render, staticRenderFns } from "./CantidadTransporta.vue?vue&type=template&id=6c1077e9&"
import script from "./CantidadTransporta.vue?vue&type=script&lang=js&"
export * from "./CantidadTransporta.vue?vue&type=script&lang=js&"
import style0 from "./CantidadTransporta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports